document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("hayd-iframe-wrapper");
  const iframe = document.getElementById("hayd-checkout-iframe");
  const closeBtn = document.getElementById("hayd-close-btn");

  let iframeLoaded = false;

  // Mark iframe loaded
  iframe.addEventListener("load", () => {
    iframeLoaded = true;
  });

  // Function to fetch compare_at_price for all cart items
  const enrichCartWithCompareAt = async (cartItems) => {
    const fetches = cartItems.map(item =>
      fetch(`/products/${item.handle}.json`)
        .then(res => res.json())
        .then(product => {
          const variant = product.product.variants.find(v => v.id === item.variant_id);
          let compareAt = variant?.compare_at_price || null;

          // Convert string to number and multiply by 100
          if (compareAt) {
            compareAt = Math.round(Number(compareAt) * 100);
          }

          return {
            ...item,
            compare_at_price: compareAt
          };
        })
        .catch(err => {
          console.error("Error fetching product:", item.handle, err);
          return { ...item, compare_at_price: null };
        })
    );
    return Promise.all(fetches);
  };

  window.addEventListener("message", async function (event) {
    if (event.origin !== "https://checkout.hayd.in") return;

    // if (event.data?.type === "REDIRECT_TO_URL") {
    //   await fetch("/cart/clear.js", { method: "POST" });
    //   await new Promise(resolve => setTimeout(resolve, 300));
    //   window.location.href = event.data.payload;
    // }

    if (event.data?.type === "REDIRECT_TO_URL") {
      try {
        // Clear Shopify cart
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Then redirect
        window.location.href = event.data.payload;
      } catch (error) {
        console.error("Cart clear failed:", error);
        // Even if clear fails, still redirect
        window.location.href = event.data.payload;
      }
    }
  });

  window.addEventListener("message", function (event) {
    if (event.origin !== "https://checkout.hayd.in") return;

    // Close iframe
    if (event.data?.type === "CLOSE_CHECKOUT_IFRAME") {
      const wrapper = document.getElementById("hayd-iframe-wrapper");
      if (wrapper) {
        wrapper.style.display = "none";
      }
    }
  });

  // Buy Now Click Handler
  document.addEventListener("click", async function (e) {
    const button = e.target.closest("#hayd-checkout-cart-drawer-btn");
    if (!button) return;

    e.preventDefault();

    // Show iframe
    wrapper.style.display = "flex";
    iframe.src = "https://checkout.hayd.in/checkout";

    try {
      // Fetch cart
      const res = await fetch("/cart.js");
      const cartData = await res.json();

      // Enrich items with compare_at_price
      const enrichedItems = await enrichCartWithCompareAt(cartData.items);
      const enrichedCart = { ...cartData, items: enrichedItems };

      // Send message to iframe
      const sendMessage = () => {
        iframe.contentWindow.postMessage(
          { type: "SHOPIFY_CART", payload: enrichedCart },
          "https://checkout.hayd.in"
        );
      };

      if (iframeLoaded) {
        sendMessage();
      } else {
        iframe.addEventListener("load", sendMessage, { once: true });
      }
    } catch (err) {
      console.error("Error fetching cart or product data:", err);
    }
  });

  // Close button
  // closeBtn.addEventListener("click", function () {
  //   wrapper.style.display = "none";
  // });
});